import React from 'react';

import { ThemeName } from '@sravni/design-system-theme';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import { useStyles, useTheme } from '@sravni/react-utils';

import sideBlockStyles from '../side-blocks.module.scss';

import styles from './app-with-qr.module.scss';

export const AppWithQr: React.FC = () => {
  const cx = useStyles(styles);
  const [theme] = useTheme();

  return (
    <div className={cx(sideBlockStyles.wrapper, 'wrapper')}>
      <Heading level={4}>
        С приложением вы не{'\u00A0'}пропустите{'\u00A0'}ответ представителя или новый комментарий{' '}
      </Heading>
      <Text size={14} className={'h-mt-8'}>
        Отсканируйте код камерой телефона и{'\u00A0'}скачайте приложение
      </Text>
      {theme === ThemeName.lager ? (
        <img
          src={require('../../../../public/images/app_300_500_light.png')}
          alt={'QR-код мобильного приложения'}
          className={cx('image', 'h-mt-32')}
        />
      ) : (
        <img
          src={require('../../../../public/images/app_300_500_dark.png')}
          alt={'QR-код мобильного приложения'}
          className={cx('image', 'h-mt-32')}
        />
      )}
    </div>
  );
};
